import React, { useState } from "react";
import ProfDashboardLayout from "./ProfDashboardLayout";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Notification from "../../../components/Notification/Notification";

const ProfNotification = () => {
  const [showFeilds, setshowFeilds] = useState("");
  const user = useSelector((state) => state.AuthSlice.user);

  const showDataReq = (index) => {
    setshowFeilds(index);
  };

  return (
    <>
      <ProfDashboardLayout>
        <Notification userId={user?.id} />
      </ProfDashboardLayout>
    </>
  );
};

export default ProfNotification;
